/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Placeholder } from '@thd-olt-component-react/core-ui';

const CardContentPlaceholder = () => {
  return (
    <>
      <Placeholder type="rect" height="54px" />
      <Placeholder type="rect" height="44px" />
    </>
  );
};

const EntryCardPlaceholder = () => (
  <div className="sui-grid sui-grid-cols-12 sui-gap-2">
    <div className="sui-col-span-4 md:sui-col-span-3">
      <Placeholder type="rect" className="sui-aspect-square sui-object-cover sui-w-full sui-max-w-[210px]" />
    </div>
    <div className="sui-flex sui-flex-col sui-justify-between sui-col-span-8 md:sui-col-span-9">
      <CardContentPlaceholder />
    </div>
  </div>
);

export { EntryCardPlaceholder };
